// @ts-nocheck

import palette from '../palette';

export const MPBetslipBandStyle = {
  backgroundColor: palette.bluegrey900,
  backgroundColorDark: palette.black,
  color: palette.white,
};

export const MPPrimaryButton = {
  color: palette.white,
  backgroundColor: palette.redwinamax500,
  backgroundShadowColor: palette.redwinamax850,
  textShadowColor: palette.redwinamax850,
};

export const MPEnrollmentWindow = {
  backgroundColor: palette.bluegrey900,
  titleColor: palette.white,
  labelColor: palette.bluegrey200,
};
